module.exports = __webpack_public_path__ + "media/images/mypage/icon/blue/ico_arrow_right-4bf976e40afc6c10c4411a40a105f70a.svg";